/**
 * Thrown to abort a user action after a validation message was already shown.
 * Filtered out in Sentry `beforeSend` (instanceof survives minification, filenames don't).
 */
export class ValidationError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ValidationError";
  }
}
